export default "__VITE_ASSET__f6224d83__"